var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 18.9883C7.28253 18.9883 7.0724 18.9095 6.90849 18.7666C6.74459 18.6236 6.63799 18.4261 6.60841 18.2107L6.60001 18.0883V7.28828C6.60008 7.06025 6.6867 6.84075 6.84238 6.67413C6.99805 6.50751 7.21117 6.40619 7.43867 6.39065C7.66616 6.37511 7.89108 6.4465 8.06797 6.5904C8.24486 6.7343 8.36053 6.93998 8.39161 7.16588L8.40001 7.28828V18.0883C8.40001 18.327 8.30519 18.5559 8.13641 18.7247C7.96762 18.8935 7.7387 18.9883 7.50001 18.9883ZM17.436 18.7243C17.2836 18.8767 17.0816 18.9694 16.8667 18.9855C16.6517 19.0015 16.4382 18.9399 16.2648 18.8119L16.164 18.7243L10.764 13.3243C10.6116 13.1719 10.5189 12.9699 10.5028 12.7549C10.4868 12.54 10.5484 12.3264 10.6764 12.1531L10.764 12.0523L16.164 6.65228C16.3248 6.49273 16.5399 6.39969 16.7662 6.39172C16.9926 6.38374 17.2137 6.46143 17.3853 6.60927C17.5569 6.75712 17.6665 6.96424 17.6921 7.18931C17.7178 7.41437 17.6576 7.64083 17.5236 7.82348L17.436 7.92428L12.672 12.6883L17.436 17.4523C17.6046 17.621 17.6992 17.8498 17.6992 18.0883C17.6992 18.3268 17.6046 18.5555 17.436 18.7243Z",
    fill: "#2F2F2F",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootBack);
export default __webpack_public_path__ + "static/media/foot-back.76da4b1507c2c4675da9ad0df20f892c.svg";
export { ForwardRef as ReactComponent };